import classcat from "classcat";
import React from "react";

import { EventData } from "@is/services/EventTracking/EventTracking.types";
import { MediaType } from "@is/types";

import ProductMedia from "./ProductMedia";
import css from "./ProductMediaSlider.module.css";
import useManageProductMediaSlider from "./hooks/useManageProductMediaSlider";

type Props = {
  medias: MediaType[];
  itemIndex: number;
  disableZoom?: boolean;
  loadedItemIndex?: number;
  animated?: boolean;
  eventData?: EventData;
};

const ProductMediaSlider = ({
  medias,
  itemIndex,
  disableZoom,
  loadedItemIndex,
  animated,
  eventData,
}: Props) => {
  const {
    isSmallScreen,
    containerRef,
    sortedMedias,
    handleSetMedias,
    handleScroll,
    isScrolling,
    handleSearchAndFooterDrawersClose,
  } = useManageProductMediaSlider({ medias });

  return (
    <div
      ref={containerRef}
      style={{ ["--loaded-item-index" as string]: loadedItemIndex || 0 }}
      className={classcat([
        css.container,
        { [css.scroll]: isScrolling },
        { [css.animation]: animated },
      ])}
      onScroll={handleScroll}
    >
      {sortedMedias?.map((media, index) => (
        <ProductMedia
          key={media.url}
          media={media}
          large={isSmallScreen ? false : index === 0}
          disableZoom={disableZoom}
          index={index}
          contentItemIndex={itemIndex}
          loadedItemIndex={loadedItemIndex}
          animated={animated}
          onSetMedias={handleSetMedias}
          onDrawersClose={handleSearchAndFooterDrawersClose}
          eventData={eventData}
        />
      ))}
    </div>
  );
};

export default ProductMediaSlider;
